export class ClipExport
{
  clipName:string = "clip";
  startTime:number = 0 ;
  endTime:number = 1;
  trimmed:boolean = false;
  trimmedStartTime:number = 0;
  trimmedEndTime:number = 1;

  fadeInDuration:number = 0;
  fadeOutDuration:number = 0;

  get duration()
  {
    return this.endTime - this.startTime;
  }

  static create( start:number, end:number, name:string = null )
  {
    let clip = new ClipExport();

    if ( name )
    {
      clip.clipName = name;
    }

    clip.startTime = start;
    clip.endTime   = end;

    return clip;  
  }

  static trim( clip:ClipExport, start:number, end:number )
  {
    clip.startTime = start;
    clip.endTime   = end;
    clip.trimmed = true;
  }

  static getStartTime( clip:ClipExport)
  {
    return clip.trimmed ? clip.trimmedStartTime : clip.startTime;
  }

  static getEndTime( clip:ClipExport)
  {
    return clip.trimmed ? clip.trimmedEndTime : clip.endTime;
  }

  static getTimeDuration( clip:ClipExport)
  {
    return ClipExport.getEndTime( clip ) - ClipExport.getStartTime( clip );
  }

}
